import RoundedImage from '../../../../components/RoundedImage';
import TrackEventLink from '../../../../components/track-event-link/TrackEventLink';
import styles from './ProfileInfoForUpdateReceiver.module.less';

const ProfileInfoForUpdateReceiver = ({
    title = '',
    subtitle = '',
    titleClass = '',
    imageSize = 40,
    imageSrc = '',
    urlForOrganizationNavigation = '',
    hideLogo = false,
}) => {
    // TODO: Replace RoundedImage with Avatar component
    return (
        <div className={styles.container}>
            {!hideLogo && (
                <div className={styles.imagesContainer}>
                    <RoundedImage src={imageSrc} size={`${imageSize}px`} className={styles.roundedImage} />
                </div>
            )}
            <div className={styles.textContainer}>
                <div className={`${styles.title} ${titleClass}`}>
                    {urlForOrganizationNavigation ? (
                        <TrackEventLink
                            className={styles.link}
                            to={urlForOrganizationNavigation}
                            action="click"
                            category="updates-org-navigation"
                        >
                            {title}
                        </TrackEventLink>
                    ) : (
                        title
                    )}
                </div>
                <div className={styles.subtitle}>{subtitle}</div>
            </div>
        </div>
    );
};

export default ProfileInfoForUpdateReceiver;
